import React from "react";

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// component
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

// typography
import TypoInfo from 'components/Typography/Info.js';
import TypoMuted from 'components/Typography/Muted.js';

// images
import FactoryIcon from 'assets/img/factory.png';
import DatabaseIcon from 'assets/img/database.png';
import ArrangementIcon from 'assets/img/cube.png';
import ResultIcon from 'assets/img/assembly.png';

import styles from 'views/component/Styles.js';

const useStyles = makeStyles(styles);

export default function InformationPage() {
    const classes = useStyles();

    return (
        <div style={{ margin: 50 }}>
            <GridContainer justify="center">
                <img src={FactoryIcon} width='90' height='90' alt=''
                    style={{ margin: 80, marginBottom: 20 }} />
            </GridContainer>
            <GridContainer justify="center">
                <TypoMuted>다음 안내에 따라 이용해주세요.</TypoMuted>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={3}>
                    <Card>
                        <CardBody>
                            <div className={classes.center}>
                                <img src={DatabaseIcon} width='70' height='70' alt='데이터 입력'
                                    style={{ margin: 10, marginBottom: 10 }} />
                                <TypoInfo>공정 모델링</TypoInfo>
                                <TypoMuted><h6>보유한 설비 정보를 입력하고<br />3D 도면에 설비를 배치합니다.</h6></TypoMuted>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Card>
                        <CardBody>
                            <div className={classes.center}>
                                <img src={ResultIcon} width='70' height='70' alt='결과보기'
                                    style={{ margin: 10, marginBottom: 10 }} />
                                <TypoInfo>결과보기</TypoInfo>
                                <TypoMuted><h6><br />최적화 결과를 확인합니다.</h6></TypoMuted>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}